(function () {
  if (window.VijaySavedProducts) return;

  function productPayload(button) {
    return {
      productId: button.dataset.productId || "",
      productHandle: button.dataset.productHandle || "",
      productTitle: button.dataset.productTitle || "",
      productVendor: button.dataset.productVendor || "",
      productType: button.dataset.productType || "",
      productTags: button.dataset.productTags || "",
      imageUrl: button.dataset.imageUrl || "",
      imageAlt: button.dataset.imageAlt || "",
      productUrl: button.dataset.productUrl || "",
      priceAmount: button.dataset.priceAmount || "",
      priceCurrency: button.dataset.priceCurrency || "",
    };
  }

  function setSaved(button, saved) {
    button.classList.toggle("is-saved", Boolean(saved));
    button.setAttribute("aria-pressed", saved ? "true" : "false");
    button.title = saved ? "Saved to your VIJAY list" : "Save to your VIJAY list";

    const label = button.querySelector(".vj-save-button__label");
    if (label) label.textContent = saved ? "Saved" : "Save";
  }

  function setLoading(button, loading) {
    button.classList.toggle("is-loading", Boolean(loading));
    button.disabled = Boolean(loading);
  }

  async function loadState(button) {
    if (!button.dataset.endpoint || button.dataset.requiresLogin === "true") return;

    try {
      const response = await fetch(button.dataset.endpoint, {
        headers: { Accept: "application/json" },
      });
      const json = await response.json();
      setSaved(button, Boolean(json.saved));
    } catch (error) {
      console.warn("Could not load VIJAY saved product state", error);
    }
  }

  async function toggle(button) {
    if (button.dataset.requiresLogin === "true") {
      window.location.href = button.dataset.loginUrl || "/account/login";
      return;
    }

    setLoading(button, true);

    try {
      const response = await fetch(button.dataset.endpoint, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ product: productPayload(button) }),
      });
      const json = await response.json();

      if (json.requiresLogin) {
        window.location.href = button.dataset.loginUrl || "/account/login";
        return;
      }

      if (!response.ok || !json.ok) {
        throw new Error(json.error || "Could not update saved product.");
      }

      setSaved(button, Boolean(json.saved));
      document.dispatchEvent(new CustomEvent("vijay:saved-product-changed", { detail: json }));
    } catch (error) {
      console.warn("Could not update VIJAY saved product", error);
    } finally {
      setLoading(button, false);
    }
  }

  function init(root) {
    const scope = root || document;
    const buttons = scope.querySelectorAll("[data-vj-save-product]:not([data-vj-save-ready])");

    buttons.forEach((button) => {
      button.dataset.vjSaveReady = "true";
      button.addEventListener("click", () => toggle(button));
      loadState(button);
    });
  }

  window.VijaySavedProducts = { init };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) init(node);
      });
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
